/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createLN2 } from '../../factoriesAny.js';
export var LN2Dependencies = {
  BigNumberDependencies,
  createLN2
};